export default __webpack_public_path__ + "media/icons/angle_bold_right_grey-17a2023a.svg";